import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Eye } from "lucide-react";

export default function FormsPage() {
  const [forms, setForms] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/v1/forms").then(setForms).catch((e) => toast.error(e.message)).finally(() => setLoading(false));
  }, []);

  const handleCreate = async () => {
    const name = prompt("Form name:");
    if (!name) return;
    try {
      const result = await api.post("/api/v1/forms", { name, fields: [] });
      setForms([{ form_id: result.formId, name, status: "active" }, ...forms]);
      toast.success("Form created");
    } catch (e: any) { toast.error(e.message); }
  };

  const handleDelete = async (id: number) => {
    if (!confirm("Delete this form?")) return;
    try { await api.delete(`/api/v1/forms/${id}`); setForms(forms.filter(f => f.form_id !== id)); toast.success("Deleted"); }
    catch (e: any) { toast.error(e.message); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Forms</h1>
        <button onClick={handleCreate} className="px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 flex items-center gap-2">
          <Plus className="w-4 h-4" /> New Form
        </button>
      </div>
      {loading ? <div className="animate-pulse space-y-3">{[1,2].map(i=><div key={i} className="h-16 bg-muted rounded-lg"/>)}</div> : forms.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">No forms yet.</div>
      ) : (
        <div className="space-y-2">
          {forms.map(f => (
            <div key={f.form_id} className="bg-card rounded-xl border border-border p-4 flex items-center gap-4">
              <div className="flex-1">
                <p className="font-medium">{f.name}</p>
                <p className="text-xs text-muted-foreground">Status: {f.status}</p>
              </div>
              <button onClick={() => toast.info("Form builder coming soon")} className="p-2 rounded-lg hover:bg-accent text-muted-foreground"><Eye className="w-4 h-4" /></button>
              <button onClick={() => handleDelete(f.form_id)} className="p-2 rounded-lg hover:bg-destructive/10 text-muted-foreground hover:text-destructive"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
